module.exports = {
	"$schema": "http://json-schema.org/draft-04/schema#",
	"title": "Fonds for time series",
	"description": "A minimal array of fonds for the <time-series> component.",
	"type": "array",
	"items": {
		"type": "object",
		"required": [
			"isin"
		],
		"properties": {
			"isin": {
				"type": "string"
			}
		}
	}
}